import React from 'react'

import Link from '../../../../global/Link'
import { TableDataInvoice } from './types'

interface LinkToInvoiceProps {
  invoiceId: TableDataInvoice['invoiceId']
  value: React.ReactNode
}

export const LinkToInvoice: React.VFC<LinkToInvoiceProps> = ({ invoiceId, value }) => (
  <Link to={`/account/transactions/invoices/${invoiceId}`}>{value}</Link>
)
